import React from 'react';
import DropboxTester from '../components/debug/DropboxTester';

export default function DropboxTesterPage() {
  return <DropboxTester />;
}